import { setCookie } from './_utility.js';

const LANGS = ['it', 'en'];

// salva la lingua scelta dal selettore in navbar; la navigazione resta quella del link.
// SameSite=Lax: nginx deve ricevere il cookie anche quando si arriva su / da un link esterno
function initLanguageSwitcher(root = document) {
    root.querySelectorAll('[data-set-lang]').forEach(function (link) {
        link.addEventListener('click', function () {
            const lang = link.dataset.setLang;
            if (LANGS.includes(lang)) {
                setCookie('lang', lang, undefined, 'lax');
            }
        });
    });
}

export { initLanguageSwitcher };
